export default __webpack_public_path__ + "static/media/hostfully_step16.aec17b5f.png";